import { render } from "./TeleportAcceptNotification.vue?vue&type=template&id=0a260af8&scoped=true"
import script from "./TeleportAcceptNotification.vue?vue&type=script&lang=js"
export * from "./TeleportAcceptNotification.vue?vue&type=script&lang=js"

import "./TeleportAcceptNotification.vue?vue&type=style&index=0&id=0a260af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a260af8"]])

export default __exports__